export default __webpack_public_path__ + "static/media/img.16dfc804.svg";